var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "advertise", on: { click: _vm.jumpToUrl } }, [
    _vm.imgUrl != ""
      ? _c("img", { attrs: { src: _vm.imgUrl } })
      : _c("div", { staticClass: "stand" }, [
          _c("img", {
            staticClass: "state-img",
            attrs: { src: require("./images/ad.png") }
          })
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05b466bf", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05b466bf","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ad/advertise.vue
// module id = 398
// module chunks = 0 1 2 3